import { create } from "zustand";
import moment from "moment";

interface FilterState {
  selectedApp: { label: string; value: string } | null;
  selectedCampaign: { label: string; value: string } | null;
  selectedTestGroup: any;
  selectedGender: any;
  selectedPlatform: any;
  selectedUserSource: any;
  selectedClient: any;
  selectedCountry: any;
  periodicity: { label: string; value: string };
  breakdowns: any[];
  internalRanges: { startDate: Date | null; endDate: Date | null; key: string };
  userInternalRanges: {
    startDate: Date | null;
    endDate: Date | null;
    key: string;
  };
  selectedCoinFilter:
    | "usage"
    | "challenge_open"
    | "challenge_app_event"
    | "challenge_app_revenue_event"
    | null;
  selectedUserApiLevel: string[];
  selectedInstallSequence: string[];
  setFilters: (filters: Partial<FilterState>) => void;
  resetFilters: () => void;
}

export const useFilterStore = create<FilterState>((set) => ({
  selectedApp: null,
  selectedCampaign: null,
  selectedTestGroup: null,
  selectedGender: null,
  selectedPlatform: null,
  selectedUserSource: null,
  selectedClient: null,
  selectedCountry: null,
  periodicity: { label: "Daily", value: "daily" },
  breakdowns: [null],
  internalRanges: {
    startDate: moment().toDate(),
    endDate: moment().toDate(),
    key: "selection",
  },
  userInternalRanges: {
    startDate: null,
    endDate: null,
    key: "selection",
  },
  selectedCoinFilter: null,
  selectedUserApiLevel: [],
  selectedInstallSequence: [],
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  resetFilters: () =>
    set({
      selectedApp: null,
      selectedCampaign: null,
      selectedTestGroup: null,
      selectedGender: null,
      selectedPlatform: null,
      selectedUserSource: null,
      selectedClient: null,
      selectedCountry: null,
      periodicity: { label: "Daily", value: "daily" },
      breakdowns: [null],
      internalRanges: {
        startDate: moment().toDate(),
        endDate: moment().toDate(),
        key: "selection",
      },
      userInternalRanges: {
        startDate: null,
        endDate: null,
        key: "selection",
      },
      selectedUserApiLevel: [],
      selectedInstallSequence: [],
    }),
}));
